import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=30b5fa59&scoped=true&"
import script from "./CompanyDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=30b5fa59&prod&lang=scss&"
import style1 from "./CompanyDetails.vue?vue&type=style&index=1&id=30b5fa59&prod&lang=css&"
import style2 from "./CompanyDetails.vue?vue&type=style&index=2&id=30b5fa59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b5fa59",
  null
  
)

export default component.exports